import { CircularProgress } from "@chakra-ui/react"
export default function Loader(){
    return(
        <CircularProgress isIndeterminate color='rgb(30,128,253)' size="120px"/>
    )
}